import React from "react";
import { useTheme } from "styled-components";

export const DocumentSvg = (props) => {
  const { width, height, color, withMagnifyingGlass } = props;

  const theme = useTheme();

  if (withMagnifyingGlass) {
    return (
      <svg width={width ?? "34"} height={height ?? "34"} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M27.3963 12.785C27.726 12.7812 28.0849 12.777 28.4111 12.777C28.7618 12.777 29.0423 13.0604 29.0423 13.4145V24.8045C29.0423 28.3179 26.223 31.1654 22.7304 31.1654H11.5794C7.93258 31.1654 4.95898 28.1762 4.95898 24.4929V9.2212C4.95898 5.70786 7.79232 2.83203 11.2849 2.83203H18.775C19.1397 2.83203 19.4202 3.12953 19.4202 3.4837V8.04536C19.4202 10.6379 21.5382 12.7629 24.105 12.777C24.7046 12.777 25.2332 12.7815 25.6957 12.7854C26.0556 12.7885 26.3755 12.7912 26.6578 12.7912C26.8575 12.7912 27.1163 12.7882 27.3963 12.785ZM27.7818 10.7173C26.6288 10.7216 25.2697 10.7173 24.292 10.7074C22.7407 10.7074 21.4629 9.41681 21.4629 7.84998V4.11564C21.4629 3.50506 22.1965 3.20189 22.6159 3.64248C23.3753 4.44005 24.4191 5.53652 25.458 6.62784C26.4932 7.71532 27.5236 8.79768 28.2629 9.57406C28.6725 10.0033 28.3723 10.7159 27.7818 10.7173Z" fill={color ?? window?.settings?.secondary_color ?? '#04333b'} />
        <ellipse cx="16.4018" cy="17.7807" rx="5.14793" ry="5.14793" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.9824 21.6289L22.0007 23.6419" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }

  return (
    <svg
      width={width ?? "12"}
      height={height ?? "14"}
      viewBox="0 0 12 14"
      fill={color ?? theme?.colour?.secondary ?? "#1DBD6B"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.20667 0.333374H8.794C10.8533 0.333374 12 1.52004 12 3.55337V10.44C12 12.5067 10.8533 13.6667 8.794 13.6667H3.20667C1.18 13.6667 0 12.5067 0 10.44V3.55337C0 1.52004 1.18 0.333374 3.20667 0.333374ZM3.38672 3.44006V3.4334H5.37939C5.66672 3.4334 5.90006 3.66673 5.90006 3.95273C5.90006 4.24673 5.66672 4.48006 5.37939 4.48006H3.38672C3.09939 4.48006 2.86672 4.24673 2.86672 3.96006C2.86672 3.6734 3.09939 3.44006 3.38672 3.44006ZM3.38672 7.49346H8.61339C8.90005 7.49346 9.13339 7.26013 9.13339 6.97346C9.13339 6.68679 8.90005 6.45279 8.61339 6.45279H3.38672C3.09939 6.45279 2.86672 6.68679 2.86672 6.97346C2.86672 7.26013 3.09939 7.49346 3.38672 7.49346ZM3.3867 10.5401H8.61337C8.87937 10.5134 9.08003 10.2861 9.08003 10.0201C9.08003 9.74675 8.87937 9.52008 8.61337 9.49342H3.3867C3.1867 9.47342 2.99337 9.56675 2.8867 9.74008C2.78003 9.90675 2.78003 10.1268 2.8867 10.3001C2.99337 10.4668 3.1867 10.5668 3.3867 10.5401Z"
      />
    </svg>
  );
};
